import { PORTFOLIO_ADMIN_CONSTANTS as C } from '../../_Shared/_MODULES/PortfolioAdminApi';
export const PROJECTS_ADMIN_API = { LIST: C.PROJECTS_LIST, SAVE: C.PROJECTS_SAVE, REMOVE: C.PROJECTS_REMOVE };
